/* Small gold details taken from the reference card: the heart and the dividers. */

export const Heart = ({ className = "" }) => (
  <svg className={`rm-motif ${className}`} viewBox="0 0 24 22" aria-hidden="true">
    <path
      d="M12 21 C5 15.5 1 11.6 1 7.2 C1 3.8 3.7 1.2 7 1.2 C9.2 1.2 11 2.4 12 4.1 C13 2.4 14.8 1.2 17 1.2 C20.3 1.2 23 3.8 23 7.2 C23 11.6 19 15.5 12 21 Z"
      fill="currentColor"
    />
  </svg>
);

/** Thin gold rule with a diamond at each end and an ornament in the middle. */
export const Divider = ({ children, className = "" }) => (
  <div className={`rm-divider ${className}`}>
    <span className="rm-divider__rule" aria-hidden="true" />
    {children}
    <span className="rm-divider__rule" aria-hidden="true" />
  </div>
);

export const HeartDivider = ({ className = "" }) => (
  <Divider className={`rm-divider--short ${className}`}>
    <Heart className="rm-divider__heart" />
  </Divider>
);
